export { default } from './VehicleInfo';
export { default as BasicInfo } from './BasicInfo';
export { default as MainCta } from './MainCta';
